import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const MainContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(2, 0, 1)
}));

export const ReasonsList = styled('ul')(({ theme }) => ({
  margin: theme.spacing(0, 0, 1)
}));

export const ReasonsTitle = styled(Typography)({
  textTransform: 'uppercase'
});
